export default "__VITE_ASSET__LJjJoQvs__"